import { contentInstanse } from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export async function fetch(params = {}, rest = {}) {
    return contentInstanse
        .get('public/page/', { params, ...rest })
        .then(({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            throw new ApiRequestError('Failed fetch page: /public/page/', params);
        })
        .catch((err) => {
            throw new ApiRequestError(`Failed fetch page: /public/page/ ${err.message}`, rest);
        });
}

export async function fetchBySlug(slug, rest = {}) {
    return contentInstanse
        .get(`public/page/${slug}`, rest)
        .then(({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            throw new ApiRequestError(`Failed fetchBySlug: public/page/${slug}`, rest);
        })
        .catch((err) => {
            throw new ApiRequestError(
                `Failed fetchBySlug: public/page/${slug} ${err.message}`,
                rest
            );
        });
}
